class Products {
	constructor () {
		this.view = $('.page-products');
		this.view.slides = this.view.find('.slide-contents .slide');

		this.view.slides.each((i, item) => {
			let swiper;
			const createSwiper = () => {
				swiper = new Swiper(item, {
					simulateTouch : true,
					slidesPerView : 1,
					pagination: {
						el: '.swiper-bullets',
						type: "bullets",
						clickable: "clickable"
					},
					breakpoints: {
						900: {
							slidesPerView: 3,
						},
					},
					navigation: {
						prevEl: '.prev',
						nextEl: '.next',
					},
				});
			}
			createSwiper()
		})

	}
}

$(function() {
	pages.products = new Products();
})



const $section = document.querySelectorAll('.cta-wrap:not(.cta-none)');
const trigger_footer =  document.querySelector('.cmn-global-footer');
// console.log(trigger_footer);
const controller = new ScrollMagic.Controller();

for(let i = 0; i < $section.length; i++) {
	let scene_01 = new ScrollMagic.Scene({
		triggerElement: trigger_footer,// トリガー
		triggerHook: 'onCenter',// トリガーが真ん中に来たら
		reverse: true,// 逆スクロールに対応
	  })
	controller.addScene([
		scene_01,
	]);
    // .addTo(controller);
	scene_01.on('progress', ()=>{
		if(!$section[i].classList.contains("cta-none")) {
			$section[i].classList.add('cta-none');// classを追加
		} else  {
			$section[i].classList.remove('cta-none');
		}
    })
}